import { render, staticRenderFns } from "./RelationshipMapping.vue?vue&type=template&id=7b842573&scoped=true&"
import script from "./RelationshipMapping.vue?vue&type=script&lang=js&"
export * from "./RelationshipMapping.vue?vue&type=script&lang=js&"
import style0 from "./RelationshipMapping.vue?vue&type=style&index=0&id=7b842573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b842573",
  null
  
)

export default component.exports